export default "__VITE_ASSET__sHRDgToD__"